import script from "./profile-page.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-page.vue?vue&type=script&setup=true&lang=js"

import "./profile-page.vue?vue&type=style&index=0&id=b775c1a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b775c1a0"]])

export default __exports__